<template>
  <div class="dashboard-container" v-loading="loading">
    <div class="title">{{ texts?.dashboard.title }}</div>
    <div class="search-wrap" role="search" aria-label="帮助文档搜索">
      <el-autocomplete
        class="search-input"
        :placeholder="texts?.placeholder"
        v-model="searchkey"
        :fetch-suggestions="querySearchAsync"
        value-key="value"
        :debounce="300"
        :trigger-on-focus="false"
        :highlight-first-item="true"
        type="search"
        name="help-center-doc-search"
        autocomplete="off"
        autocapitalize="off"
        :spellcheck="false"
        popper-class="dashboard-search-popper"
        @select="onSearchSelect"
      >
        <template #prefix>
          <img
            style="width: 14px; height: 14px"
            :src="searchIcon"
            alt=""
          />
        </template>
      </el-autocomplete>
    </div>
    <div class="navigation">
      <div
        class="item-box"
        v-for="(item, index) in navigationList"
        :key="index"
      >
        <div class="item-box-header">
          <div class="item-box-left">
            <img :src="navIconList[index]" alt="" />
            <span>{{ item.name }}</span>
          </div>
          <div class="more" @click="toArticleDetail(item.articleList[0].id)">
            {{ texts?.dashboard.more
            }}<img :src="require('@/assets/icons/more.svg')" alt="" />
          </div>
        </div>
        <div class="router-link-item">
          <router-link
            v-for="(article, index) in item.articleList"
            :key="index"
            :to="{ path: '/blog', query: { blogid: article.id } }"
          >
            {{ article.title }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="recommend">
      <div class="recommend-title">{{ texts?.dashboard.recommend }}</div>
      <div class="recommend-container">
        <div
          class="recommend-item"
          v-for="item in recommendList"
          :key="item.columnId"
        >
          <div class="columnTitle flex-between">
            {{ item.name }}
            <div class="more" @click="toArticleDetail(item.articleList[0].id)">
              {{ texts?.dashboard.more }}
              <img src="../assets/icons/more.svg" alt="" />
            </div>
          </div>
          <div
            class="articleTitle flex-between"
            v-for="article in item.articleList"
            :key="article.id"
            @click="toArticleDetail(article.id)"
          >
            <span class="flex-align-center"
              ><img style="margin-right: 6px" :src="documentIcon" alt="" />{{
                article.title
              }}</span
            >
            <span style="color: #10121666">{{ article.updateTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecommendedArticles, getMedproArticleList } from "@/api/blog.js"
import { mapState } from "vuex"
import { languageMap } from "../data/list"

export default {
  name: "Dashboard",
  data() {
    return {
      searchIcon: require("@/assets/icons/search.svg"),
      documentIcon: require("@/assets/icons/dashboard_document.svg"),
      navIconList: [
        require("@/assets/icons/platform.svg"),
        require("@/assets/icons/delivery.svg"),
        require("@/assets/icons/search_advertising.svg"),
        require("@/assets/icons/change.svg"),
      ],
      loading: false,
      searchkey: "",
      navigationList: [],
      recommendList: [
        // {
        //   columnId: 1,
        //   name: "专栏1",
        //   articleList: [
        //     { id: 1, title: "文章标题1", time: "2025-02-11 14:23:00" },
        //     { id: 2, title: "文章标题2", time: "2025-02-11 14:23:00" },
        //   ],
        // },
      ],
    }
  },
  computed: {
    ...mapState(["texts", "selectedLanguage"]),
  },
  watch: {
    selectedLanguage(newVal, oldVal) {
      this.getRecommendList()
    },
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      const q = (queryString || "").trim()
      if (!q) {
        cb([])
        return
      }
      try {
        const { data } = await getMedproArticleList({
          searchWord: q,
          languageFlag: languageMap[this.selectedLanguage].id,
        })
        const list = Array.isArray(data) ? data : []
        cb(list.map(({ id, title }) => ({ id, value: title })))
      } catch (e) {
        console.error(e)
        cb([])
      }
    },
    onSearchSelect(item) {
      if (item && item.id != null) {
        this.toArticleDetail(item.id)
        this.searchkey = ""
      }
    },
    toArticleDetail(id) {
      this.$router.push({
        path: "/blog",
        query: {
          blogid: id,
        },
      })
    },
    async getRecommendList() {
      this.loading = true
      try {
        const id = languageMap[this.selectedLanguage].id
        const { data } = await getRecommendedArticles(id)
        // 按order排序，前4个是navigation，剩下的为recommend
        const order_list = data.sort((a, b) => a.order - b.order)
        this.navigationList = order_list.slice(0, 4)
        this.recommendList = order_list.slice(4)
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getRecommendList()
  },
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 24px;
  background: url("../assets/images/background.png") no-repeat center/cover;
  box-sizing: border-box;
  overflow: auto;
  .title {
    font-size: 32px;
    line-height: 32px;
    font-weight: 600;
    font-family: "EnglishFontT2";
    color: #010007;
    margin: 80px 0 30px 0;
  }
  .search-wrap {
    width: 660px;
  }
  .search-input {
    width: 100%;
    ::v-deep(.el-input__inner) {
      width: 660px;
      height: 48px;
      border: none;
      border-radius: 8px;
      padding-left: 52px;
      background-color: #ffffff;
    }
    ::v-deep(.el-input__prefix) {
      left: 0;
    }
  }
  .navigation {
    width: 100%;
    display: flex;
    gap: 24px;
    margin-top: 60px;
    .item-box {
      flex: 1;
      max-width: 25%;
      // height: 106px;
      margin-bottom: 24px;
      padding: 24px;
      background-color: #ffffff;
      border-radius: 8px;
      font-size: 16px;
      line-height: 16px;
      .item-box-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-size: 18px;
        font-family: "EnglishFontT3";
        color: #010007;
        .item-box-left {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 20px;
          line-height: 24px;
          font-weight: 500;
          color: #010007;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .router-link-item {
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
      }
      a {
        margin-right: 14px;
        font-size: 17px;
        color: #010007cc;
        text-decoration: none;
        // &:hover {
        //   color: #010007;
        // }
      }
    }
  }
  .more {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 17px;
    font-weight: 400;
    color: #10121666;
    cursor: pointer;
  }
  .recommend {
    width: 100%;
    // height: 450px;
    padding: 24px;
    border-radius: 8px;
    background-color: #ffffff;
    box-sizing: border-box;
    .recommend-title {
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      color: #010007;
      margin-bottom: 30px;
      font-family: "EnglishFontT3";
    }
    .recommend-container {
      display: flex;
      flex-wrap: wrap;
      gap: 32px 120px;
      .recommend-item {
        width: calc((100% - 240px) / 3);
        .columnTitle {
          margin-bottom: 22px;
          color: #010007;
          font-size: 19px;
          line-height: 18px;
          font-weight: 400;
        }
        .articleTitle {
          padding-bottom: 17px;
          font-size: 17px;
          // line-height: 16px;
          color: #010007cc;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
